<template>
  <div class="blog-based-layout">

    <template v-for="(article, index) in blog.articles">
      <!-- H E R O  B A N N E R -->
      <UiHeroTop v-if="blogStore.articleHasTag(article, 'Herobanner')" :article="article" />
      <!-- T E X T + I M A G E -->
      <template
        v-else-if="blogStore.articleHasTag(article, 'ImagesToTheRight') || blogStore.articleHasTag(article, 'ImagesToTheLeft')">
        <!--UiImageFlip :article="article"  :showcaption="true" class="md:mt-16" /-->
        <UiTextImageCols :article="article" :showcaption="true"></UiTextImageCols>
      </template>
      <!-- T E X T B A N N E R -->
      <template v-else-if="blogStore.articleHasTag(article, 'Textbanner')">
        <UiContentwrapper>
          <UiFullcolumn>
            <UiTextBanner :article="article" class="mt-16" />
          </UiFullcolumn>
        </UiContentwrapper>

      </template>
      <!-- B U T T O N -->
       <template v-else-if="blogStore.articleHasTag(article, 'Button')">
        <UiContentwrapper>
          <UiExtraNarrowColumn>
            <ContentButton :article="article" class="mb-16" />
          </UiExtraNarrowColumn>
        </UiContentwrapper>

      </template>
      <!-- Y O U T U B E -->
      <template v-else-if="blogStore.articleHasTag(article, 'Youtube')">
        <UiContentwrapper>
          <UiFullcolumn>
            <UiYouTubeVideo :article="article" />
          </UiFullcolumn>
        </UiContentwrapper>
      </template>

      <!-- Y O U T U B E – V I D E O S E T -->
      <template v-else-if="blogStore.articleHasTag(article, 'Videoset')">
        <UiContentwrapper>
          <UiFullcolumn>
            <ContentVideoSet :article="article" />
          </UiFullcolumn>
        </UiContentwrapper>
      </template>
      <!-- T E S T I M O N I A L S -->
      <template v-else-if="blogStore.articleHasTag(article, 'Testimonial')">
        <UiContentwrapper>
          <UiFullcolumn>
            <UiTestimonial :article="article" />
          </UiFullcolumn>
        </UiContentwrapper>
      </template>

      <!-- S L I D E R S E C T I O N-->
      <template v-else-if="blogStore.articleHasTag(article, 'Slider')">
        <ContentSliderByBlogSlug class="py-4 md:py-16 mb-12" :slug="article.handle"
          :headline="article.title" />
      </template>

      <!-- B U L L E T  L I S T -->

      <template v-else-if="blogStore.articleHasTag(article, 'Bulletlist')">
        <ContentBulletList :article="article" class="mb-12 py-18 bg-gravaasuperlightwarmgray" />
        
      </template>

      <!-- P R O D U C T S — G R A V E L W H E E L S -->

      <template v-else-if="blogStore.articleHasTag(article, 'Gravelwheelsets')">
        <ContentGravaaWheels class="" :headline="article.contenthtml" :collection="'gravel-wheelsets'" />
      </template>

      <!-- E V E N T S L I D E R-->

      <template v-else-if="blogStore.articleHasTag(article, 'Testlocations')">
        <ContentLocationSlider class="mt-12 pt-6 md:pt-24 md:pb-32 bg-gravaasuperlightwarmgray" :article="article" />
        <ContentPartnerLogos class="mb-12 mt-24" />
      </template>

      <!-- D E F A U L T / A C C O R D I O N -->
      <!-- JUST ONE IMAGE, NO CONTENT -->
      <UiArticleImage v-else-if="article.image && !article.contenthtml" :fit="'contain'" :article="article"
        class="w-full mt-8 mb-8" :showcaption="true" :overlay="false" :sizes="'sm:1024px md:1024px lg:1280px xl:1500'">
        <div v-if="article.altText" class="text-white bg-gravaablack/70 p-5 m-0 ">
          {{ article.altText }}
        </div>
      </UiArticleImage>

      <UiContentwrapper v-else>
        <UiNarrowcolumn v-if="blogStore.articleHasTag(article, 'Accordion')">
          <UiFaqItem :article="article" :key="article.id" class="border-black"
            :class="{ 'border-b': blogStore.articleHasTag(article, 'Border') }" />
        </UiNarrowcolumn>
        <template v-else>

          <UiExtraNarrowColumn v-if="article.contenthtml" class="mb-10">
            <!--h2 class="mt-10 md:mt-20">{{ article.title }}</h2-->
            <div v-html="article.contenthtml" class="content-html"></div>

          </UiExtraNarrowColumn>
          <!-- IMAGE + CONTENT -->
          <UiNarrowcolumn v-if="article.image && article.contenthtml">
            <UiArticleImage :fit="'contain'" :modifiers="modifiers" :article="article" class="w-full mt-8 mb-8"
              :showcaption="true" :overlay="false" :sizes="'sm:1024px md:1024px lg:1280px xl:1500'">
              <div v-if="article.altText" class="text-white bg-gravaablack/70 p-5 m-0 ">
                {{ article.altText }}
              </div>
            </UiArticleImage>

          </UiNarrowcolumn>

        </template>

      </UiContentwrapper>
      
    </template>


  </div>

  <!--ContentBlogBasedContent v-for="(article, index) in blogStore.filterArticlesByTag(blog, tag)" :article="article" :index="index" v-if="tag != 'Herobanner'"/-->



</template>

<script setup>
import { ContentVideoSet } from '#components';
import { useBlogStore } from '@/stores/blogStore';
const UiFaqItem = defineAsyncComponent(() => import('@/components/ui/FaqItem.vue'));
const blogStore = useBlogStore();

// Definiera props
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
});

function tagsToSlugs(article) {
  const tags = new Set();

  if (article.tags) {
    article.tags.forEach(tag => {
      const slug = tag
        .toLowerCase()
        .trim()
        .replace(/[\s\W-]+/g, '-')
        .replace(/^-+|-+$/g, '');
      tags.add(slug);
    });
  }

  return Array.from(tags).join(' ');
}

function getUniqueTags() {
  const tags = new Set();
  props.blog.articles.forEach(article => {
    if (article.tags) {
      article.tags.forEach(tag => tags.add(tag));
    }
  });
  return Array.from(tags);
}


// Prepare filtered FAQ articles for SEO
const faqArticles = computed(() => {
  return props.blog.articles.filter(article => {
    return article.tags && !article.tags.includes('Herobanner');
  }).map(article => ({
    title: article.title,
    content: article.content,
    handle: article.handle
  }));
});


</script>
